import { createFileRoute } from "@tanstack/react-router";
import Imprint from "@/pages/Imprint";

export const Route = createFileRoute("/imprint")({
  component: Imprint,
});
